import { component } from 'picoapp';
import Swiper, { A11y } from 'swiper';

const playVideos = (videos) => {
  videos.forEach((video) => {
    video.muted = true;
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(() => {});
    }
  });
};

const pauseVideos = (videos) => {
  videos.forEach((video) => {
    video.pause();
  });
};

const getPlayableVideos = (card) => {
  const videos = [...card.querySelectorAll('video')];
  if (videos.length === 0) return [];

  const visibleVideos = videos.filter((video) => video.offsetParent !== null);
  return visibleVideos.length > 0 ? visibleVideos : videos;
};

const updateButton = (button, paused) => {
  if (!button) return;
  button.setAttribute('aria-pressed', paused ? 'true' : 'false');
  button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');

  const pauseIcon = button.querySelector('[data-fit-video-icon="pause"]');
  const playIcon = button.querySelector('[data-fit-video-icon="play"]');

  if (pauseIcon) pauseIcon.classList.toggle('hidden', paused);
  if (playIcon) playIcon.classList.toggle('hidden', !paused);
};

const setCardPaused = (card, paused) => {
  card.dataset.fitVideoPaused = paused ? 'true' : 'false';
  const button = card.querySelector('[data-fit-video-toggle]');
  updateButton(button, paused);

  if (paused) {
    pauseVideos([...card.querySelectorAll('video')]);
  } else {
    playVideos(getPlayableVideos(card));
  }
};

export default component((node) => {
  const swiperElement = node.querySelector('[data-fit-video-swiper]');
  const cardCount = Number(node.dataset.fitVideoCardCount || 0);
  const cards = [...node.querySelectorAll('[data-fit-video-card]')];

  if (swiperElement) {
    const slidesPerViewDesktop = Math.min(Math.max(cardCount, 1), 3);

    new Swiper(swiperElement, {
      modules: [A11y],
      slidesPerView: 1.2,
      spaceBetween: 8,
      watchOverflow: true,
      breakpoints: {
        1024: {
          slidesPerView: slidesPerViewDesktop,
        },
      },
    });
  }

  cards.forEach((card) => {
    setCardPaused(card, true);
  });

  node.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fit-video-toggle]');
    if (!button || !node.contains(button)) return;

    const card = button.closest('[data-fit-video-card]');
    if (!card) return;

    const paused = card.dataset.fitVideoPaused === 'true';
    setCardPaused(card, !paused);
  });

  const modal = node.closest('[data-modal]');
  if (!modal) {
    cards.forEach((card) => {
      setCardPaused(card, false);
    });
    return;
  }

  const syncPlayback = () => {
    const isOpen = modal.classList.contains('open') && !modal.hasAttribute('hidden');
    cards.forEach((card) => {
      setCardPaused(card, !isOpen);
    });
  };

  const observer = new MutationObserver(syncPlayback);
  observer.observe(modal, { attributes: true, attributeFilter: ['class', 'hidden'] });
  syncPlayback();
});
